export { default as GoogleRedirect } from './GoogleRedirect.vue'
